export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/check-circle-gray.8ef7c530.svg","height":11,"width":10,"blurWidth":0,"blurHeight":0};